/**
 * React Query key factory — clés structurées pour le cache.
 *
 * DETTE TECHNIQUE (F-M5 audit 2026-05-08) — Plusieurs hooks utilisent encore
 * des chaînes de queryKey hardcodées au lieu d'entrées centralisées dans ce
 * fichier :
 *   - hooks/useEnrichClient.ts, useEnterprises*.ts, useClientFinancialHealth.ts
 *     → namespace `enrichment.*` à créer (identity / financials / scoring /
 *       scoring-history / events / alerts).
 *   - hooks/useLearners.ts, useClients.ts → mélangent encore `[LISTING_ENDPOINT]`
 *     en chaîne brute avec `queryKeys.{clients,learners}.all`. Convergence
 *     vers une clé unique par module à finaliser.
 * Migration mécanique : tracer les usages, ajouter ici les namespaces puis
 * remplacer les chaînes brutes — pas urgent (les invalidations actuelles
 * fonctionnent), à isoler dans son propre commit.
 *
 * DETTE TECHNIQUE (F-M4 audit 2026-05-08) — ~12 hooks ont leurs types inline
 * au lieu d'un fichier `.types.ts` séparé : useContacts, useEnrichClient,
 * useEnterprises*, useLearnerBulkImport, useLearnerMerge, useClientFinancial
 * Health, useClientKpis, useLeadTypes, useFadingHighlight, useCursorPagination.
 * Pattern à reproduire (cf. useClients/.types.ts) : extraire au minimum les
 * types domain (`Contact`, `EnterpriseSearchItem`, `ScoringHistoryItem`).
 *
 * Découpage interne (refactor 2026-05-13) : les sous-namespaces sont définis
 * dans `queryKeys.{core,catalog,logistics,pedagogy,crm}.ts`. Ce fichier
 * reste l'unique point d'import public (`@/lib/queryKeys`) et expose la
 * structure globale identique pour ne casser aucun consommateur.
 */

import { coreKeys } from './queryKeys.core'
import { pedagogyKeys } from './queryKeys.pedagogy'
import { catalogKeys } from './queryKeys.catalog'
import { logisticsKeys } from './queryKeys.logistics'
import { crmKeys } from './queryKeys.crm'
import { salesKeys } from './queryKeys.sales'
import { tendersKeys } from './queryKeys.tenders'
import { searchKeys } from './queryKeys.search'
import { signatureKeys } from './queryKeys.signature'
import { notificationsKeys } from './queryKeys.notifications'
import { notificationSettingsKeys } from './queryKeys.notification-settings'
import { instructorsKeys } from './queryKeys.instructors'
import { documentsKeys } from './queryKeys.documents'
import { workflowsKeys } from './queryKeys.workflows'
import { qualityKeys } from './queryKeys.quality'
import { satisfactionKeys } from './queryKeys.satisfaction'
import { checklistsKeys } from './queryKeys.checklists'
import { portalKeys } from './queryKeys.portal'
import { customFieldsKeys } from './queryKeys.customFields'

export const queryKeys = {
    ...instructorsKeys,
    ...documentsKeys,
    ...coreKeys,
    ...pedagogyKeys,
    ...catalogKeys,
    ...logisticsKeys,
    ...crmKeys,
    ...salesKeys,
    ...tendersKeys,
    ...searchKeys,
    ...signatureKeys,
    ...notificationsKeys,
    ...notificationSettingsKeys,
    ...workflowsKeys,
    ...qualityKeys,
    ...satisfactionKeys,
    ...checklistsKeys,
    ...portalKeys,
    ...customFieldsKeys,
}
